import Components from '../../Components';
import { COWORKING_DAY_PASS_PATH } from './constants';

const { containerTypes } = Components.Routes;

const RouteConfig = {
  path: COWORKING_DAY_PASS_PATH,
  exact: true,
  name: 'navigation.menu.coworkingDayPass',
  private: true,
  type: containerTypes.PAGE,
  requiresMemberPortalAccess: true,
  isHardRedirect: true,
};

export default RouteConfig;
